import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SectionRating } from './SectionRating';

interface SectionExplanationProps {
  score: number | string;
  explanation: string | object;
}

export const SectionExplanation: React.FC<SectionExplanationProps> = ({ score, explanation }) => {
  if (!explanation) {
    return null;
  }

  return (
    <div className="mt-4 pt-4 border-t border-gray-500">
      <div className="flex items-center gap-2 mb-3">
        <p className="text-sm font-medium text-[#CECFD2]">
          Explanation for
        </p>
        <SectionRating score={score} />
        <p className="text-sm font-medium text-[#CECFD2]">
          rating
        </p>
      </div>
      <div className="bg-[#1A1A1A] rounded-lg p-4 border border-gray-500">
        <div className="text-sm leading-relaxed text-[#CECFD2] space-y-2">
          <div className="prose prose-sm prose-invert max-w-none [&>p]:text-[#CECFD2] [&>ul]:text-[#CECFD2] [&>ol]:text-[#CECFD2] [&>h1]:text-[#CECFD2] [&>h2]:text-[#CECFD2] [&>h3]:text-[#CECFD2]">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {typeof explanation === 'string'
                ? explanation
                : typeof explanation === 'object'
                  ? JSON.stringify(explanation)
                  : 'No explanation available'}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};